module.exports = __webpack_public_path__ + "static/media/5.de36a137.mp3";